import * as React from "react";
const SvgIcCopyFilled = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M4 4V16H1V1H16V4H4ZM23 6V23H6V6H23Z" fill="currentColor" /></svg>;
export default SvgIcCopyFilled;